import React from 'react'

import { BarChart, DashboardChartPaper } from 'components'

import { routes } from 'Routes'
import theme from 'theme'

const CookiesByConsentType = ({ banners, id }) => {
  const data = { names: [], full: [], partial: [], denied: [] }

  banners.reduce((acc, item) => {
    acc.names.push(item.name)
    acc.full.push(item.fullCount)
    acc.partial.push(item.partialCount)
    acc.denied.push(item.deniedCount)
    return acc
  }, data)

  return (
    <DashboardChartPaper
      title="Cookies por Tipo de Consentimento"
      subtitle="Aceitos, parciais e recusados"
      redirect={routes.cookies.consents}
    >
      <BarChart
        id={id}
        names={data.names}
        series={[
          { name: 'Aceitos', data: data.full || [] },
          { name: 'Parciais', data: data.partial || [] },
          { name: 'Recusados', data: data.denied || [] },
        ]}
        heightValue={250}
        colors={[
          theme.palette.dashboard.chart.cookies.accepted,
          theme.palette.dashboard.chart.cookies.partial,
          theme.palette.dashboard.chart.cookies.denied,
        ]}
        showLabels
      />
    </DashboardChartPaper>
  )
}

export default CookiesByConsentType
